export const templateTexts = {
  "Fundamenter EXC3 ": {
    B5: {
      "Header 5": {
        1: "100%",
        2: "20% / Maks.",
        3: "20% / Maks.",
        4: "20% / Maks.",
        5: "20% / Maks.",
        6: "20% / Maks.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Udgravningsdimensioner stemmer overens med konstruktionstegninger +-15 mm",
        3: "Udgravningen er fri for fremmede legemer og nedskridning",
        4: "Armeringsmængde og afstande stemmer overens med konstruktionstegninger +-10mm",
        5: "Dæklag som foreskrevet på konstruktionstegninger +-10mm",
        6: "Fundamente stemmer overens med konstruktionstegninger og overholder følgende udførelsestolerancer:\nKote: +5/-15 mm\nPosition i planet: +-25mm\nPlanhed: 9mm/2m",
      },
      "Header 3": {
        1: "Under udførelse",
        2: "Før støbning",
        3: "Før støbning",
        4: "Efter montering, før støbning",
        5: "Efter montering, før støbning",
        6: "Før og efter støbning",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuelt + Måling",
        3: "Visuelt + Fotodokumentation",
        4: "Visuel + Måling",
        5: "Visuel + Måling",
        6: "Visuel + Måling",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Udgravningsdimensioner",
        3: "Fri udgravning",
        4: "Armering",
        5: "Dæklag",
        6: "Kote, placering og planhed",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på. Der redegøres for valget af udvalgte dele",
        2: "Angiv den afmålte geometri i kontrolresultatet, evt. med supplerende fotodokumentation. ",
        3: "Angiv afvigelser og bemærkninger i kontrolresultatet, suppleres med fotodokumentation",
        4: "Angiv de anvendte armeringsstørrelser, armerings afstande i kontrolresultat, evt. med supplerende fotodokumentation af opmåling. ",
        5: "Angiv det afmålte dæklag, evt. med supplerende fotodokumentation af opmåling. ",
        6: "Angiv det afmålte",
      },
    },
    B6: {
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Overordnede geometriske mål, placering og udførelse er korrekt",
        3: "Konstruktionens overordnede funktion og tilstand",
      },
      "Header 3": {
        1: "Efter udførelse",
        2: "Efter udførelse",
        3: "Efter udførelse",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Ingen afvigelser som overgår udførelsestolerancerne",
        3: "Ingen store deformationer, revner eller tegn på overbelastning",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på. Der redegøres for valget af udvalgte dele",
        2: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
        3: "Angiv afvigelser i kontrolresultat. Der skal foreligge fotodokumentation om der forekommer afvigelser eller ej. ",
      },
    },
    B4: {
      "Header 5": {
        1: "100%",
        2: "20%",
        3: "20%",
        4: "20%",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på. Der redegøres for valget af udvalgte dele",
        2: "Angiv betonklasse, mængde og leverandør på følgesedlen i kontrolresultatet",
        3: "Angiv armeringstype, -størrelser, mængder og leverandør på følgesedlen i kontrolresultatet",
        4: "Angivning af evt. fejl eller skader. I tilfælde af ingen fejl og mangler, skal der stadig foreligge billeddokumentation på dette. ",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Følgesedler/Visuel",
        3: "Følgesedler/Visuel",
        4: "Billeddokumentation/Visuelt",
      },
      "Header 3": {
        1: "Ved modtagelse",
        2: "Ved levering",
        3: "Ved levering",
        4: "Ved levering",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nCE-mærkning, Betonklasse, og mængde",
        3: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nCE-mærkning, armeringstype, -størrelser og mængder.",
        4: "Det leveret har ingen synlige fejl og mangler:\nTransportskader eller fejl fra produktion",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Beton",
        3: "Armering",
        4: "Fejl og mangler",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
      },
    },
    B1: {
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår: \nKonsekvensklasse,\nKonstruktionsklasse, Geoteknisk klasse og\nUdførelsesklasse",
        3: "Følgende fremgår:\nBetonklasse, Eksponeringsklassen, Armeringstype",
        5: "Følgende fremgår:\nTværsnit, Dæklag, Armeringstørrelse, Armeringsplacering",
        6: "Følgende koter fremgår:\nKote på fundamenter",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
        5: "100%",
        6: "100%",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        5: "4",
        6: "5",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivning af klasser i kontrolresultat",
        3: "Angivning af materialeklasser i kontrolresultat",
        5: "Angivning af geometri i kontrolresultat",
        6: "Angivning af koter i kontrolresultat",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        5: "Visuel kontrol",
        6: "Visuel kontrol",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        5: "Inden opstart",
        6: "Inden opstart",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Kontrol af klasser",
        3: "Materialeklasser",
        5: "Geometri",
        6: "Koter",
      },
    },
    B3: {
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på. Der redegøres for valget af udvalgte dele",
        2: "Angivelse af bestilte/indkøbte materialer i kontrolresultatet",
        3: "Angivelse leverandør(er) i kontrolresultat",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Indkøb/bestilling",
        3: "CE-Mærke",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 5": {
        1: "100%",
        2: "20%",
        3: "20%",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Overensstemmelse med udførelsesgrundlaget af materialeklasser for følgende:\nBeton, Armering ",
        3: "Byggevarer leveres CE-mærket.",
      },
    },
    B2: {
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        4: "Inden opstart",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        4: "Visuel kontrol",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Informationer",
        3: "Bygbarhed",
        4: "Arbejdsmiljø",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på. Der redegøres for valget af udvalgte dele",
        2: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkriterier i kontrolresultatet",
        3: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkravene, med vurdering om det er bygbart i kontrolresultatet.",
        4: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, og en vurdering heraf.",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår tydeligt:\nUdførelsesklasser, materialekrav og tolerancer",
        3: "Der fremgår tilstrækkeligt materiale til følgende:\nudførlighed, tolerancer, materialer, grænseflader ",
        4: "Kan håndteres sikkert og under overholdelse af gældende arbejdsmiljøsregler",
      },
      "Header 5": {
        1: "100%",
        2: "20%",
        3: "20%",
        4: "20%",
      },
    },
  },

  "Fundamenter EXC2": {
    B5: {
      "Header 3": {
        1: "Under udførelse",
        2: "Før støbning",
        3: "Før støbning",
        4: "Efter montering, før støbning",
        5: "Efter montering, før støbning",
        6: "Før og efter støbning",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
        5: "10%",
        6: "10%",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv den afmålte geometri i kontrolresultatet, evt. med supplerende fotodokumentation. ",
        3: "Angiv afvigelser og bemærkninger i kontrolresultatet, suppleres med fotodokumentation",
        4: "Angiv de anvendte armeringsstørrelser, armerings afstande i kontrolresultat, evt. med supplerende fotodokumentation af opmåling. ",
        5: "Angiv det afmålte dæklag, evt. med supplerende fotodokumentation af opmåling. ",
        6: "Angiv det afmålte",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Udgravningsdimensioner stemmer overens med konstruktionstegninger +-15 mm",
        3: "Udgravningen er fri for fremmede legemer og nedskridning",
        4: "Armeringsmængde og afstande stemmer overens med konstruktionstegninger +-10mm",
        5: "Dæklag som foreskrevet på konstruktionstegninger +-10mm",
        6: "Fundamente stemmer overens med konstruktionstegninger og overholder følgende udførelsestolerancer:\nKote: +5/-15 mm\nPosition i planet: +-25mm\nPlanhed: 9mm/2m",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Udgravningsdimensioner",
        3: "Fri udgravning",
        4: "Armering",
        5: "Dæklag",
        6: "Kote, placering og planhed",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuelt + Måling",
        3: "Visuelt + Fotodokumentation",
        4: "Visuel + Måling",
        5: "Visuel + Måling",
        6: "Visuel + Måling",
      },
    },
    B3: {
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af bestilte/indkøbte materialer i kontrolresultatet",
        3: "Angivelse leverandør(er) i kontrolresultat",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Indkøb/bestilling",
        3: "CE-Mærke",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Overensstemmelse med udførelsesgrundlaget af materialeklasser for følgende:\nBeton, Armering ",
        3: "Byggevarer leveres CE-mærket.",
      },
    },
    B2: {
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Informationer",
        3: "Bygbarhed",
        4: "Arbejdsmiljø",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkriterier i kontrolresultatet",
        3: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkravene, med vurdering om det er bygbart i kontrolresultatet.",
        4: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, og en vurdering heraf.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår tydeligt:\nUdførelsesklasser, materialekrav og tolerancer",
        3: "Der fremgår tilstrækkeligt materiale til følgende:\nudførlighed, tolerancer, materialer, grænseflader ",
        4: "Kan håndteres sikkert og under overholdelse af gældende arbejdsmiljøsregler",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        4: "Visuel kontrol",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        4: "Inden opstart",
      },
    },
    B4: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Beton",
        3: "Armering",
        4: "Fejl og mangler",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Følgesedler/Visuel",
        3: "Følgesedler/Visuel",
        4: "Billeddokumentation/Visuelt",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv betonklasse, mængde og leverandør på følgesedlen i kontrolresultatet",
        3: "Angiv armeringstype, -størrelser, mængder og leverandør på følgesedlen i kontrolresultatet",
        4: "Angivning af evt. fejl eller skader. I tilfælde af ingen fejl og mangler, skal der stadig foreligge billeddokumentation på dette. ",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nCE-mærkning, Betonklasse, og mængde",
        3: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nCE-mærkning, armeringstype, -størrelser og mængder.",
        4: "Det leveret har ingen synlige fejl og mangler:\nTransportskader eller fejl fra produktion",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
      },
      "Header 3": {
        1: "Ved modtagelse",
        2: "Ved levering",
        3: "Ved levering",
        4: "Ved levering",
      },
    },
    B1: {
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        5: "Inden opstart",
        6: "Inden opstart",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
        5: "100%",
        6: "100%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Kontrol af klasser",
        3: "Materialeklasser",
        5: "Geometri",
        6: "Koter",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivning af klasser i kontrolresultat",
        3: "Angivning af materialeklasser i kontrolresultat",
        5: "Angivning af geometri i kontrolresultat",
        6: "Angivning af koter i kontrolresultat",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        5: "Visuel kontrol",
        6: "Visuel kontrol",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår: \nKonsekvensklasse,\nKonstruktionsklasse, Genoteknisk klasse og\nUdførelsesklasse",
        3: "Følgende fremgår:\nBetonklasse, Eksponeringsklassen, Armeringstype",
        5: "Følgende fremgår:\nTværsnit, Dæklag, Armeringstørrelse, Armeringsplacering",
        6: "Følgende koter fremgår:\nKote på fundamenter",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        5: "4",
        6: "5",
      },
    },
    B6: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Overordnede geometriske mål, placering og udførelse er korrekt",
        3: "Konstruktionens overordnede funktion og tilstand",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Ingen afvigelser som overgår udførelsestolerancerne",
        3: "Ingen store deformationer, revner eller tegn på overbelastning",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 3": {
        1: "Efter udførelse",
        2: "Efter udførelse",
        3: "Efter udførelse",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
        3: "Angiv afvigelser i kontrolresultat. Der skal foreligge fotodokumentation om der forekommer afvigelser eller ej. ",
      },
    },
  },
  "Træspær EXC2": {
    B2: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Informationer",
        3: "Bygbarhed",
        4: "Arbejdsmiljø",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår tydeligt:\nUdførelsesklasser, materialekrav og tolerancer",
        3: "Der fremgår tilstrækkeligt materiale til følgende:\nUdførlighed, tolerancer, materialer, grænseflader ",
        4: "Kan håndteres sikkert og under overholdelse af gældende arbejdsmiljøsregler",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkriterier i kontrolresultatet",
        3: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkravene, med vurdering om det er bygbart i kontrolresultatet.",
        4: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, og en vurdering heraf.",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        4: "Inden opstart",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        4: "Visuel kontrol",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
      },
    },
    B6: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Overordnede geometriske mål, placering og udførelse er korrekt",
        3: "Konstruktionens overordnede funktion og tilstand",
      },
      "Header 3": {
        1: "Efter udførelse",
        2: "Efter udførelse",
        3: "Efter udførelse",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
        3: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Ingen afvigelser som overgår udførelsestolerancerne",
        3: "Ingen store deformationer, revner eller tegn på overbelastning",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
    },
    B5: {
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
        5: "10%",
        6: "10%",
        7: "10%",
        8: "10%",
        9: "10%",
        10: "10%",
        11: "10%",
      },
      "Header 3": {
        1: "Under udførelse",
        2: "Efter montering",
        3: "Efter montering af spær",
        4: "Efter montering",
        5: "Efter montering",
        6: "Efter montering",
        7: "Efter montering",
        8: "Efter montering",
        9: "Efter montering",
        10: "Efter montering",
        11: "Efter montering",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel/Foto",
        3: "Opmåling, lodstok + tommestok",
        4: "Opmåling, lodstok + tommestok",
        5: "Visuel kontrol + opmåling",
        6: "Visuel kontrol + opmåling",
        7: "Visuel kontrol + opmåling",
        8: "Visuel kontrol",
        9: "Visuel kontrol",
        10: "Visuel kontrol",
        11: "Visuel kontrol",
      },
      "Header 2": {
        1: "Udført egenkontrol",
        2: "Vinkelbeslag",
        3: "Lod, vægge",
        4: "Lod, spær",
        5: "Planhed, spær",
        6: "c/c-afstand spær",
        7: "c/c-afstand lægter",
        8: "Skot",
        9: "Kipbjælke",
        10: "Vindtrækbånd",
        11: "Forankring",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Fotodokumentation",
        3: "Resultat skrives i kontrolresultat",
        4: "Resultat skrives i kontrolresultat",
        5: "Fotodokumentation",
        6: "Fotodokumentation",
        7: "Fotodokumentation",
        8: "Fotodokumentation",
        9: "Fotodokumentation",
        10: "Fotodokumentation",
        11: "Fotodokumentation",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Korrekt antal vinkelbeslag og sømmønster iht. udførelsesgrundlag.",
        3: "Max 5 mm",
        4: "Max 5 mm",
        5: "Min. 3 bjælker skal måles over.\nTolerance, max 3 mm/m\n",
        6: "Tolerance ± 10 mm",
        7: "Tolerance ± 5mm",
        8: "Kontrol af fastgørelse iht. udførelsesgrundlag",
        9: "Kipbjælke monteres i gavlspær",
        10: "Kontrol af fastgørelse iht. udførelsesgrundlag",
        11: "Kontrol af fastgørelse iht. udførelsesgrundlag",
      },
    },
    B1: {
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        5: "Visuel kontrol",
      },
      "Header 1": {
        1: "1",
        2: "2",
        5: "3",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår: \nKonsekvensklasse,\nKonstruktionsklasse, Brandklasse,\nUdførelsesklasse",
        5: "Følgende fremgår:\nOverensstemmelse med udførelsesgrundlag:\nTværsnit, spændvidde",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Kontrolklasse noteres i kontrolskema",
        5: "Angivning af geometri i kontrolresultat",
      },
      "Header 2": {
        1: "Udført egenkontrol",
        2: "Kontrol af klasser",
        5: "Geometri",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        5: "Inden opstart",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        5: "100%",
      },
    },
    B3: {
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af bestilte/indkøbte materialer i kontrolresultatet",
        3: "Angivelse leverandør(er) i kontrolresultat",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Indkøb/bestilling",
        3: "CE-Mærke",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Overensstemmelse med udførelsesgrundlaget af materialeklasser for følgende:\nTræ, afstivninger, fastgørelser",
        3: "Byggevarer leveres CE-mærket.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
    },
    B4: {
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv træstyrke, mængde og leverandør på følgesedlen i kontrolresultatet",
        3: "Angiv type, -størrelser, mængder og leverandør på følgesedlen i kontrolresultatet",
        4: "Angivning af evt. fejl eller skader. I tilfælde af ingen fejl og mangler, skal der stadig foreligge billeddokumentation på dette. ",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Spær",
        3: "Fastgørelser",
        4: "Fejl og mangler",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
      },
      "Header 3": {
        1: "Ved modtagelse",
        2: "Ved levering",
        3: "Ved levering",
        4: "Ved levering",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Følgesedler/Visuel",
        3: "Følgesedler/Visuel",
        4: "Billeddokumentation/Visuelt",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nTræstyrker og mængde",
        3: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nstyrker og antal",
        4: "Det leveret har ingen synlige fejl og mangler:\nTransportskader eller fejl fra produktion",
      },
    },
  },
  "Murværk EXC2": {
    B1: {
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        5: "Inden opstart",
      },
      "Header 2": {
        1: "Udført egenkontrol",
        2: "Kontrol af klasser",
        5: "Geometri",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        5: "Visuel kontrol",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        5: "100%",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår: \nKonsekvensklasse,\nKonstruktionsklasse, Brandklasse,\nUdførelsesklasse",
        5: "Følgende fremgår:\nOverensstemmelse med udførelsesgrundlag:\nStenstørrelser, tykkelser, længder, bredder",
      },
      "Header 1": {
        1: "1",
        2: "2",
        5: "3",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Kontrolklasse noteres i kontrolskema",
        5: "Angivning af geometri i kontrolresultat",
      },
    },
    B2: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Informationer",
        3: "Bygbarhed",
        4: "Arbejdsmiljø",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        4: "Inden opstart",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår tydeligt:\nUdførelsesklasser, materialekrav og tolerancer",
        3: "Der fremgår tilstrækkeligt materiale til følgende:\nUdførlighed, tolerancer, materialer, grænseflader ",
        4: "Kan håndteres sikkert og under overholdelse af gældende arbejdsmiljøsregler",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkriterier i kontrolresultatet",
        3: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkravene, med vurdering om det er bygbart i kontrolresultatet.",
        4: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, og en vurdering heraf.",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        4: "Visuel kontrol",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
      },
    },
    B3: {
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af bestilte/indkøbte materialer i kontrolresultatet",
        3: "Angivelse leverandør(er) i kontrolresultat",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Overensstemmelse med udførelsesgrundlaget af materialeklasser for følgende:\nFormur, bagmur, skillevægge, tegloverliggere, mørtel",
        3: "Byggevarer leveres CE-mærket.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Indkøb/bestilling",
        3: "CE-Mærke",
      },
    },
    B6: {
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Ingen afvigelser som overgår udførelsestolerancerne",
        3: "Ingen store deformationer, revner eller tegn på overbelastning",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
        3: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Overordnede geometriske mål, placering og udførelse er korrekt",
        3: "Konstruktionens overordnede funktion og tilstand",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 3": {
        1: "Efter udførelse",
        2: "Efter udførelse",
        3: "Efter udførelse",
      },
    },
    B5: {
      "Header 2": {
        1: "Udført egenkontrol",
        2: "Vandrette mål i planet, murværk",
        3: "Topkoter, murværk",
        4: "Lod, murværk",
        5: "Planhed, murværk",
        6: "Afsætning af vindues- og døråbninger",
        7: "Murværksfalse, forskydning af for- og bagmur",
        8: "Murværksfalse, lodtolerancer",
        9: "Vinkel, murhjørner",
        10: "Planhed, murhjørner",
        11: "Fuger, murværk",
        12: "Tegloverliggere",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Tolerance ± 10 mm",
        3: "Tolerancer:\nFacadevægge: ± 15 mm\nSkillevægge: ± 10 mm\n",
        4: "Tolerancer:\nFacadevægge: ± 6 mm / 2 m\nSkillevægge: ± 10 mm\n",
        5: "Tolerancer:\nFacadevægge: ± 6 mm / 2 m\nSkillevægge: ± 10 mm\n",
        6: "Tolerance ± 10 mm.",
        7: "Tolerance ± 2 mm",
        8: "Tolerance ± 2 mm / 2 m ",
        9: "Tolerance ± 3 mm / 2 m",
        10: "Tolerance ± 3 mm / 2 m",
        11: "Tolerancer:\nLiggefuger: n ± 4 mm\nStudsfuger: n + 8 / -4 mm",
        12: "Vederlag, fuger og murfolie skal stemme overens iht. udførelsesgrundlaget",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
        5: "10%",
        6: "10%",
        7: "10%",
        8: "10%",
        9: "10%",
        10: "10%",
        11: "10%",
        12: "10%",
      },
      "Header 3": {
        1: "Under udførelse",
        2: "Under udførelse",
        3: "Under udførelse",
        4: "Under udførelse",
        5: "Under udførelse",
        6: "Under udførelse",
        7: "Under udførelse",
        8: "Under udførelse",
        9: "Under udførelse",
        10: "Under udførelse",
        11: "Under udførelse",
        12: "Under udførelse",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Noteres i kontrolskema",
        3: "Fotodokumentation",
        4: "Fotodokumentation",
        5: "Fotodokumentation",
        6: "Fotodokumentation",
        7: "Fotodokumentation",
        8: "Fotodokumentation",
        9: "Fotodokumentation",
        10: "Fotodokumentation",
        11: "Fotodokumentation",
        12: "Fotodokumentation",
      },
      "Header 1": {
        1: "1",
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        10: 10,
        11: 11,
        12: 12,
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol + opmåling",
        3: "Visuel kontrol + opmåling",
        4: "Visuel kontrol + opmåling",
        5: "Visuel kontrol + opmåling med retholt",
        6: "Visuel kontrol + opmåling",
        7: "Visuel kontrol + opmåling",
        8: "Visuel kontrol + opmåling",
        9: "Visuel kontrol + opmåling med teodolit/totalstation",
        10: "Visuel kontrol + opmåling med retholt",
        11: "Visuel kontrol + opmåling med stål lineal eller tommestok. ",
        12: "Visuel kontrol",
      },
    },
    B4: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: 4,
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nStyrker og mængde",
        3: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nAntal og spændvidde",
        4: "Det leveret har ingen synlige fejl og mangler:\nTransportskader eller fejl fra produktion",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv type, mængde og leverandør på følgesedlen i kontrolresultatet",
        3: "Angiv overligger og leverandør på følgesedlen i kontrolresultatet",
        4: "Angivning af evt. fejl eller skader. I tilfælde af ingen fejl og mangler, skal der stadig foreligge billeddokumentation på dette. ",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Murværk",
        3: "Tegloverliggere",
        4: "Fejl og mangler",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Følgesedler/Visuel",
        3: "Følgesedler/Visuel",
        4: "Billeddokumentation/Visuelt",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 3": {
        1: "Ved modtagelse",
        2: "Ved levering",
        3: "Ved levering",
        4: "Ved levering",
      },
    },
  },
  "Stålaltan EXC2": {
    B5: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Tidligere udførte konstruktioner",
        3: "Samlinger",
        4: "Balustre",
        5: "Opbevaring på pladsen",
      },
      "Header 3": {
        1: "Under udførelse",
        2: "Før opsætning",
        3: "Efter montering",
        4: "Efter montering",
        5: "Før opsætning",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuelt + Måling",
        3: "Visuelt + Fotodokumentation",
        4: "Visuel + Fotodokumentation",
        5: "Visuel + Fotodokumentation",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Eksisterende konstruktioner stemmer overens med udførelsesgrundlaget, samt eventuelle trækprøver",
        3: "Samling mod eksisterende, sikres en effektiv fastgørelse, og stemmer overens med udførelsesgrundlaget",
        4: "Det sikres at fastførelse af balustre stemmer overens med udførelsesgrundlaget",
        5: "Det sikres at opbevaring på pladsen ikke forringer materialets styrkeparametre",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv den afmålte geometri i kontrolresultatet, evt. med supplerende fotodokumentation. ",
        3: "Angiv afvigelser og bemærkninger i kontrolresultatet, suppleres med fotodokumentation",
        4: "Angiv de fastgørelsesprincip med supplerende fotodokumentation. ",
        5: "Angiv hvorledes altanen er opbevaret",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
        5: "10%",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
      },
    },
    B4: {
      "Header 1": {
        1: "1",
        2: "2",
        4: 4,
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Følgesedler/Visuel",
        4: "Billeddokumentation/Visuelt",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv leverandør på følgesedlen i kontrolresultatet",
        4: "Angivning af evt. fejl eller skader. I tilfælde af ingen fejl og mangler, skal der stadig foreligge billeddokumentation på dette. ",
      },
      "Header 3": {
        1: "Ved modtagelse",
        2: "Ved levering",
        4: "Ved levering",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        4: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Stål (Altan)",
        4: "Fejl og mangler",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår ved modtagelse, og i overensstemmelse med bestilte:\nCE-mærkning, stålstyrke, mængde og geometri i sin helhed",
        4: "Det leveret har ingen synlige fejl og mangler:\nTransportskader eller fejl fra produktion",
      },
    },
    B3: {
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af bestilte/indkøbte materialer i kontrolresultatet",
        3: "Angivelse leverandør(er) i kontrolresultat",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Overensstemmelse med udførelsesgrundlaget af udførelsesklasser for følgende:\nStål",
        3: "Byggevarer leveres CE-mærket.",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Indkøb/bestilling",
        3: "CE-Mærke",
      },
    },
    B1: {
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivning af klasser i kontrolresultat",
        3: "Angivning af styrke i kontrolresultat",
        5: "Angivning af geometri af profiler i kontrolresultat",
        6: "Angivning af koter i kontrolresultat",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår: \nKonsekvensklasse,\nKonstruktionsklasse, Korrosionskategori og\nUdførelsesklasse",
        3: "Følgende fremgår:\nStålstyrke",
        5: "Følgende fremgår:\nTværsnit",
        6: "Følgende koter fremgår:\nPlacering",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
        5: "100%",
        6: "100%",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        5: "Inden opstart",
        6: "Inden opstart",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        5: "Visuel kontrol",
        6: "Visuel kontrol",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Kontrol af klasser",
        3: "Materialeklasser",
        5: "Geometri",
        6: "Koter",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        5: "4",
        6: "5",
      },
    },
    B6: {
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Overordnede geometriske mål, placering og udførelse er korrekt",
        3: "Konstruktionens overordnede funktion og tilstand",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angiv kontrolleret punkter med eventuelle afvigelser i kontrolresultat. Understøttes af fotodokumentation.",
        3: "Angiv afvigelser i kontrolresultat. Der skal foreligge fotodokumentation om der forekommer afvigelser eller ej. ",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Ingen afvigelser som overgår udførelsestolerancerne",
        3: "Ingen store deformationer eller tegn på overbelastning",
      },
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
      },
      "Header 5": {
        1: "100%",
        2: "100%",
        3: "100%",
      },
      "Header 3": {
        1: "Efter udførelse",
        2: "Efter udførelse",
        3: "Efter udførelse",
      },
    },
    B2: {
      "Header 6": {
        1: "Visuel kontrol",
        2: "Visuel kontrol",
        3: "Visuel kontrol",
        4: "Visuel kontrol",
      },
      "Header 7": {
        1: "Uafhængig kontrollant har gennemgået egenkontrollen og hvilke udvalgte dele som er udført supplerende kontrol på",
        2: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkriterier i kontrolresultatet",
        3: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, hertil oplistes acceptkravene, med vurdering om det er bygbart i kontrolresultatet.",
        4: "Angivelse af dokument/tegnings nr. hvor kontrollen er udført, og en vurdering heraf.",
      },
      "Header 5": {
        1: "100%",
        2: "10%",
        3: "10%",
        4: "10%",
      },
      "Header 3": {
        1: "Inden opstart",
        2: "Inden opstart",
        3: "Inden opstart",
        4: "Inden opstart",
      },
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
      },
      "Header 4": {
        1: "Uafhængig kontrollant udfører kontrol af egenkontrol, suppleret med kontrol af udvalgte dele - som vurderes størst risiko for fejl",
        2: "Følgende fremgår tydeligt:\nUdførelsesklasser, materialekrav og tolerancer",
        3: "Der fremgår tilstrækkeligt materiale til følgende:\nudførlighed, tolerancer, materialer, grænseflader ",
        4: "Kan håndteres sikkert og under overholdelse af gældende arbejdsmiljøsregler",
      },
      "Header 2": {
        1: "Kontrol af egenkontrol er udført",
        2: "Informationer",
        3: "Bygbarhed",
        4: "Arbejdsmiljø",
      },
    },
  },
  "Tom skabelon": {
    B1: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
    B2: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
    B3: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
    B4: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
    B5: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
    B6: {
      "Header 1": {
        1: "1",
        2: "2",
        3: "3",
      },
      "Header 2": {
        1: "",
        2: "",
        3: "",
      },
      "Header 3": {
        1: "",
        2: "",
        3: "",
      },
      "Header 4": {
        1: "",
        2: "",
        3: "",
      },
      "Header 5": {
        1: "",
        2: "",
        3: "",
      },
      "Header 6": {
        1: "",
        2: "",
        3: "",
      },
      "Header 7": {
        1: "",
        2: "",
        3: "",
      },
    },
  },
};
